import _ from 'underscore';
import { getCustomizedOption } from './columns/customize-option';

function processCategory(
  columns, mandatoryColumns, aggregationRestrictions,
  columnNames, helpLinkIds
) {
  return _.map(columns, (value, key) => {
    const node = {
      // value (type info) is not used by column chooser, but we need it for report data grid
      key,
      name: _.result(columnNames, key, key),
      type: _.result(value, 'DisplayType', ''),
      sortable: _.has(value, 'Sortable') ? value.Sortable : true,
    };

    if (aggregationRestrictions[key]) {
      node.forbiddenTimeGrains = aggregationRestrictions[key];
    }
    if (mandatoryColumns[key]) {
      node.selectOption = 'mandatory';
    }
    if (_.has(helpLinkIds, key)) {
      node.helpTopic = helpLinkIds[key];
    }
    const customizedOption = getCustomizedOption({ columnKey: key });

    return { ...node, ...customizedOption };
  });
}

export function processColumns(
  categories, mandatoryColumns,
  aggregationRestrictions = {}, columnNames = {}, helpLinkIds = {}
) {
  return _.map(categories, (category, key) => ({
    name: _.result(columnNames, key, key),
    type: key,
    options: processCategory(
      category, mandatoryColumns, aggregationRestrictions,
      columnNames, helpLinkIds
    ),
  }));
}
